import { ProductReviewCardProps } from '@restworld/ui-ds';

import {
  BinocularGirlIllustration,
  PersonWithRestworldCupIllustration,
  TimeManagementIllustration,
  CheckoutIllustration,
} from '@restworld/utils-common';

export const productReviews: ProductReviewCardProps[] = [
  {
    reviewerRating: 10,
    reviewerReview: 'product_description_quote_1',
    reviewerName: 'Luca Cutrufelli, CEO & Founder',
    reviewerCompany: 'Feat Srl',
    reviewerProfilePic: '/utils-assets/product-reviewers/luca-cutrufelli-feat-ceo-founder.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/feat-srl-logo.png',
  },
  {
    reviewerRating: 10,
    reviewerReview: 'product_description_quote_2',
    reviewerName: 'Elisa Neri, CEO e Co-Founder',
    reviewerCompany: 'Tuttofabrodo',
    reviewerProfilePic: '/utils-assets/product-reviewers/elisa-neri-tuttofabrodo-ceo-founder.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/tuttofabrodo-logo.png',
  },
  {
    reviewerRating: 8,
    reviewerReview: 'product_description_quote_3',
    reviewerName: 'Stefania Aliprandi, Founder',
    reviewerCompany: 'Saint',
    reviewerProfilePic: '/utils-assets/product-reviewers/stefania-saint-founder.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/saint-logo.png',
  },
  {
    reviewerRating: 9,
    reviewerReview: 'product_description_quote_4',
    reviewerName: "Diego D'Andretta, Chef",
    reviewerCompany: 'Ristorante Da Diego',
    reviewerProfilePic: '/utils-assets/product-reviewers/diego-ristorante-da-diego-chef.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/ristorante-da-diego-logo.png',
  },
  {
    reviewerRating: 9,
    reviewerReview: 'product_description_quote_5',
    reviewerName: 'Alberto Ferrari, Manager',
    reviewerCompany: 'Food&Company',
    reviewerProfilePic: '/utils-assets/product-reviewers/alberto-ferrari-food-and-company-manager.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/food-and-company-logo.png',
  },
  {
    reviewerRating: 10,
    reviewerReview: 'product_description_quote_6',
    reviewerName: 'Mauro Virdis, Chef Patron',
    reviewerCompany: 'Trattoria Secondo Me',
    reviewerProfilePic: '/utils-assets/product-reviewers/mauro-virdis-trattoria-secondo-me-chef-patron.png',
    reviewerCompanyLogo: '/utils-assets/product-reviewers/trattoria-secondo-me-logo.png',
  },
];

export const productAdvantages = [
  {
    title: 'dont_waste_time',
    subtitle: 'receive_pre_filtered_profiles_ready_for_interview',
    illustration: <TimeManagementIllustration />,
  },
  {
    title: 'cheaper_than_agencies',
    subtitle: 'no_percentage_on_who_you_hire_just_a_clear_price',
    illustration: <CheckoutIllustration />,
  },
  {
    title: 'true_experts_in_the_sector',
    subtitle: 'we_understand_what_your_business_really_needs_beyond_simple_questionnaires',
    illustration: <PersonWithRestworldCupIllustration width="108" height="80" />,
  },
  {
    title: 'maximum_control_zero_hassle',
    subtitle: 'manage_everything_from_platform_key',
    illustration: <BinocularGirlIllustration width="108" height="80" />,
  },
];
export const productWorkingSteps = [
  'product_description_working_step_1',
  'product_description_working_step_2',
  'product_description_working_step_3',
  'product_description_working_step_4',
  'product_description_working_step_5',
  'product_description_working_step_6',
];

export const productFeatures = [
  'initial_thirty_minute_interview_with_a_dedicated_specialist',
  'writing_and_publishing_the_ad_on_12_plus_portals',
  'send_your_job_offer_to_hundreds_of_target_candidates_in_database',
  'screening_and_selection_of_profiles',
  'minimum_guaranteed_submission_key',
  'support_for_organizing_interviews',
  'no_extra_costs_if_you_hire',
];

export const howItWorksData = [
  { title: 'tell_us_what_you_need', subtitle: 'for_each_job_offer_we_quickly_fill_out_fifty_five_variables_together' },
  { title: 'lets_get_to_work', subtitle: 'multi_channel_publishing_key' },
  { title: 'receive_the_best_candidates_in_a_few_days', subtitle: 'we_will_send_you_a_first_list_of_candidates_key' },
];
